"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PoundPerCubicFoot = exports.SlugPerCubicFeet = exports.GramPerCubicCentiMeter = exports.KilogramPerCubicMeter = void 0;
var uom_1 = require("uom");
var UnitDivide = require("../unit-divide");
var volume_1 = require("./volume");
var mass_1 = require("./mass");
// Density
exports.KilogramPerCubicMeter = UnitDivide.massByVolume("KilogramPerCubicMeter", uom_1.BaseUnits.Kilogram, volume_1.CubicMeter);
exports.GramPerCubicCentiMeter = UnitDivide.massByVolume("GramPerCubicCentiMeter", mass_1.Gram, volume_1.CubicCentiMeter);
exports.SlugPerCubicFeet = UnitDivide.massByVolume("SlugPerCubicFeet", mass_1.Slug, volume_1.CubicFeet);
exports.PoundPerCubicFoot = UnitDivide.massByVolume("PoundPerCubicFoot", mass_1.PoundLb, volume_1.CubicFeet);
//# sourceMappingURL=density.js.map